// What the API answers to a like toggle sent against a state it doesn't hold:
// `like` on an episode already liked (from another device, say), `unlike` on
// one that isn't. The server's state is the truth — `useEpisodeLike` refetches
// it and the UI realigns — so `errorLink` leaves these two out of Sentry.
const STALE_LIKE_CODES = ["EPISODE_ALREADY_LIKED", "EPISODE_NOT_LIKED"];

export const isLikeOperation = (operationName: string | undefined) =>
  operationName === "Like" || operationName === "Unlike";

export const isStaleLikeError = ({
  extensions,
}: {
  extensions?: Record<string, unknown>;
}): boolean => STALE_LIKE_CODES.includes(String(extensions?.code));
